/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../widgets/livewidget/nls/StringResources'
], function (StringResources) {
	'use strict';

	class SmartsRecommenderError extends Error {

		// Smarts Recommender status codes
		static get STATUS() {
			return {
				OK: 0,
				NO_SMARTS_MODULE_SPECIFIED: 1,
				SMARTS_MODULE_NOT_FOUND: 2,
				SMARTS_MODULE_TIMEOUT: 3,
				JSON_ERROR_IN_INPUT: 4,
				UNKNOWN_CHART_TYPE: 5,
				MISSING_REQUIRED_PARAMETERS: 6,
				UNKNOWN_CHART_SPECIFIED: 7,
				NO_UNBOUND_COLUMNS: 8,
				INVALID_LEARNING_DIRECTIVE: 9,
				INVALID_ACTION_TYPE: 10,
				INVALID_ACTION_PAYLOAD: 11,
				COLUMNS_NOT_FROM_SAME_OR_JOINED_DATASET: 12,
				MISSING_ACTION: 13,
				SMARTS_MODULE_NOT_READY: 14,
				NO_COLUMNS: 15,
				INVALID_BINDING: 16,
				ERROR: 100
			};
		}

		/**
		 * Static property to load SmartsRecommenderError common message
		 */
		static get msg() {
			// ensure the common message is loaded only once
			if (!SmartsRecommenderError._message) {
				SmartsRecommenderError._message = StringResources.get('recommendRequestFailed');
			}
			return SmartsRecommenderError._message;
		}

		constructor(status, details) {
			super(SmartsRecommenderError.msg);

			this.status = status;
			this.details = details;
		}
	}

	// common message appied to all SmartsRecommenderError instances
	SmartsRecommenderError._message = null;

	return SmartsRecommenderError;
});
